import React, { useState, useReducer, useContext, useEffect } from 'react';
import { Table, Page } from '../../components';

import { default as SupplierNew } from './new';
import { default as GoodsList } from './goods';
import { default as GoodsImport } from './goodsImport';
import {
  getList,
  getListCount,
  deleteById,
  checkCanDelete,
  insert,
  update,
  insertGoods,
  insertGoodsPrice,
  download,
  downloadTemplate
} from '../../services/Supplier';
import { message, Modal, Button, Menu } from 'antd';
import './style';
import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  ImportOutlined,
  ExportOutlined,
  DownloadOutlined
} from '@ant-design/icons';
import { MasterContext } from '../../App';

export default React.forwardRef((props, ref) => {
  const { user, country, currency, currentUser, authorities } = useContext(MasterContext);
  const [isShowNew, setShowNew] = useState(false);
  const [isShowEdit, setShowEdit] = useState(false);
  const [isLoadding, setLoadding] = useState(false);
  const [isShowGoods, setShowGoods] = useState(false);
  const [isShowImport, setShowImport] = useState(false);
  const [selectedSupplierId, setSelectedSupplierId] = useState(undefined);
  const [keyword, setKeyword] = useState(undefined);

 

  const initialState = {
    total_rows: 0,
    rows: [],
    sort: { order: 'desc', sort: 'updated' },
    pagination: { limit: 10, offset: 0 },
    views: []
  };

  const onSearch = (keyword) => {
    setPage(1, state.pagination.limit);
    if ((keyword || '').trim().length === 0) setKeyword(undefined);
    else setKeyword(keyword);
  }

  const setPage = (page, pageSize) => {
    dispatch({ type: 'pagination', data: { limit: pageSize, offset: (page - 1) * pageSize } });
  }

  const setSelected = (selected) => {
    dispatch({ type: 'selected', data: selected });
  }

  function reducer(state, action) {
    switch (action.type) {
      case 'list':
        return Object.assign({}, state, { rows: action.data });
      case 'pagination':
        return Object.assign({}, state, { pagination: action.data });
      case 'total_rows':
        return Object.assign({}, state, { total_rows: action.data });
      case 'selected':
        const rows = state.rows;
        for (let i = 0; i < rows.length; i++) {
          if ((action.data || []).indexOf(i) > -1) {
            rows[i].selected = true;
          } else {
            rows[i].selected = false;
          }
        }
        return Object.assign({}, state, { rows: rows });
      case 'new':
        return { total: state.total + 1 };
      case 'edit':
        return { total: state.total };
      case 'delete':
        return { total: state.total - 1 };
      default:
        throw new Error();
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    setLoadding(true);
    var p1 = new Promise((resolve, reject) => {
      getListCount(keyword).then(data => {
        dispatch({ type: 'total_rows', data: data });
        resolve(true);
      });
    });

    var p2 = new Promise((resolve, reject) => {
      getList(state.pagination, undefined, keyword).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    Promise.all([p1, p2]).then(values => {
      setLoadding(false);
    });
  }, [state.pagination, keyword]);

  const afterClose = (e) => {

  }

  const onClickSupplier = (index) => {
    setSelectedSupplierId(index);
    setShowEdit(true);
  }

  const onClickGoods = (index) => {
    setSelectedSupplierId(index);
    setShowGoods(true);
  }

  const reloadSupplier = () => {
    var p1 = new Promise((resolve, reject) => {
      getListCount().then(data => {
        dispatch({ type: 'total_rows', data: data });
        resolve(true);
      });
    });

    var p2 = new Promise((resolve, reject) => {
      getList(state.pagination).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    return Promise.all([p1, p2]).then(values => {
      //setLoadding(false);
    });
  }


  const onNewCallback = async (values) => {
    try {
      const key = 'create_supplier';
      console.log('onNewCallback:', values);
      message.loading({ content: `正在新建供应商 [${values.name}]...`, key });
      insert(values).then(() => {
        reloadSupplier().then(() => {
          setShowNew(false);
          message.success({ content: `新建供应商成功 [#${values.name}]`, key, duration: 2 });
        });
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onDeleteCallback = async (value) => {
    try {
      const key = 'delete_supplier';
      console.log('onDeleteCallback:', value);

      const arr = [];
      let datas = [];
      value.forEach(x=> {
        arr.push(new Promise((resolve, reject)=> {
          checkCanDelete(x).then(data=> {
            data.forEach(y=> {
              if (!datas.find(z=>z.po_code === y.po_code)) {
                datas.push(y);
              }
            })
            resolve(data);
          })
        }))
      });
      Promise.all(arr).then(() => {
        if (datas.length > 0 ) {
          Modal.error({
            title: '删除错误',
            content: <span>
              <strong>供应商已被下列订单使用，不能删除。</strong><br/>
                {
                  datas.map(x=> {
                    return <div><strong>{x.po_code}</strong> - {x.no}</div>
                  })
                }
            </span>
          });
          return;
        }
        message.loading({ content: `正在删除供应商 ...`, key });
        deleteById(value.join(',')).then((data) => {
          reloadSupplier().then(() => {
            message.success({ content: `删除供应商成功 `, key, duration: 2 });
          })
        })
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const onCloseGoodsCallback = async (refresh) => {
    try {
      setShowGoods(false);
      reloadSupplier();
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const onSaveGoodsCallback = async (value) => {
    try {
      const key = 'create_supplier_goods';
      console.log('onSave:', value);
      message.loading({ content: `正在修改供应商产品 [${selectedSupplier.name}]...`, key });
      insertGoods(selectedSupplier.id, value.goods).then(() =>
        insertGoodsPrice(selectedSupplier.id, value.prices)).then(() =>
          reloadSupplier().then(() => {
            setShowGoods(false);
            message.success({ content: `修改客户产品成功 [#${selectedSupplier.name}]`, key, duration: 2 });
          }));
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onSaveCallback = async (values) => {
    try {
      const key = 'update_supplier';
      console.log('onSaveCallback:', values);
      message.loading({ content: `正在修改供应商 [${values.name}]...`, key });
      update(values.id, values).then(() => {
        reloadSupplier().then(() => {
          setShowEdit(false);
          message.success({ content: `修改供应商成功 [#${values.name}]`, key, duration: 2 });
        });
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }



  const { total_rows, rows } = state;
  const selectedSupplier = rows[selectedSupplierId] || {};

  const showDeleteConfirm = () => {
    const deleted = rows.filter(x => x.selected);
    const names = [];
    const ids = [];
    deleted.map((item) => { names.push(<div>{item.name}</div>); ids.push(item.id) })
    Modal.confirm({
      title: '确定删除当前项目吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{names}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDeleteCallback(ids)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const downloadSupplierTemplate = () => {
    const key = 'download';
    message.loading({ content: '正在生成供应商模板...', key, duration: 20 });

    downloadTemplate("supplier_template").then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = "supplier_template_" + new Date().getTime();
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `供应商模板下载成功`, key, duration: 2 });
      }
    });
  }
  const downloadSupplier = () => {
    const key = 'download';
    message.loading({ content: '正在生成供应商数据...', key, duration: 20 });
    download().then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = "supplier_data_" + new Date().getTime();
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `供应商数据下载成功`, key, duration: 2 });
      }
    });
  }

  const optionMenu = [
    <div>
      {(authorities.find(x => x === 'delete_supplier') || currentUser.category_id === 1) && <Button onClick={showDeleteConfirm} type="danger" icon={<DeleteOutlined />}>
        <span style={{ padding: '0 1rem' }}>删除供应商</span>
      </Button>}
    </div>
  ];

  const newOptionMenu = (
    <Menu>
      <Menu.Item key="1" onClick={() => setShowImport(true)} icon={<ImportOutlined />}>
        <span style={{ padding: '0 1rem', color: 'blue' }}><Button size="small" type="link">从模板导入</Button></span>
      </Menu.Item>
      <Menu.Item key="1" onClick={() => downloadSupplier(true)} icon={<ExportOutlined />}>
        <span style={{ padding: '0 1rem', color: 'blue' }}><Button size="small" type="link">导出到Excel</Button></span>
      </Menu.Item>
      <Menu.Divider>
      </Menu.Divider>
      <Menu.Item key="2" onClick={() => downloadSupplierTemplate(true)} icon={<DownloadOutlined />}>
        <span style={{ padding: '0 1rem' }}>下载空白模板</span>
      </Menu.Item>
    </Menu>
  );

  return (
    <div style={{ padding: '0.5rem 1.5rem' }}  >
      <Table
        showFilter={true}
        onSearch={onSearch}
        onSearchPlaceHolder="请输入供应商名称"
        setSelectedCallback={setSelected}
        setPageCallback={setPage}
        hasCheckbox={true}
        isLoadding={isLoadding}
        expandable={false}
        optionMenu={optionMenu}
        title="供应商管理"
        newLabel="新建供应商"
        showNewLabel={authorities.find(x => x === 'create_supplier') || currentUser.category_id === 1}
        newOptionMenu={newOptionMenu}
        showFooter={true}
        rows={rows}
        total_rows={total_rows}
        onNew={() => setShowNew(!isShowNew)}
        relation={
          {
            country_id: { data: country, field: 'name_cn' },
            currency_id: { data: currency, field: 'name_cn' },
          }
        }
        header={[
          {
            label: '供应商名称', width: '200px', item: 'name', sortable: 'true', render:
              (text, row, index) => {
                return <span>{row.abbr && '[' + row.abbr + ']'} <Button
                  onClick={() => onClickSupplier(index)}
                  type="link"
                  size="small"
                  style={{ padding: 0 }}>
                  {text}
                </Button>
                </span>
              }
          },
          {
            label: '详细地址', width: '380px', item: 'address', render: (item, row, index) => {
              return <span>[{row.country_name}] {item}</span>
            }
          },
          { label: '联系人', width: '100px', item: 'contact' },
          { label: '电话', width: '120px', item: 'tel' },
          { label: '邮箱', width: '160px', item: 'email' },
          {
            label: '供应产品', width: '120px', align: 'center', item: 'goods_count', align: 'center', render: (text, row, index) => {
              return <Button onClick={() => onClickGoods(index)} type="link" size="small">{text || text > 0 ? text : '添加产品'}</Button>
            }
          },
          { label: '备注', width: '280px', item: 'remark' },
        ]}
        bordered={true} />
      <Page
        title="新建供应商"
        width="720px"
        onCloseCallback={() => setShowNew(!isShowNew)}
        afterClose={afterClose}
        body={<SupplierNew mode="new" onCloseCallback={() => setShowNew(!isShowNew)} onSaveCallback={onNewCallback} />}
        visible={isShowNew} />
      <Page
        title="修改供应商"
        width="720px"
        onCloseCallback={() => setShowEdit(!isShowEdit)}
        afterClose={afterClose}
        body={<SupplierNew mode="edit" onCloseCallback={() => setShowEdit(!isShowEdit)} supplier={rows[selectedSupplierId]} onSaveCallback={onSaveCallback} />}
        visible={isShowEdit} />
      <Page
        title={`供应产品明细 [${selectedSupplier.name}]`}
        isMaximize={true}
        width="1024px"
        onCloseCallback={onCloseGoodsCallback}
        afterClose={afterClose}
        body={<GoodsList onCloseCallback={onCloseGoodsCallback} supplier={rows[selectedSupplierId]} onSaveCallback={onSaveGoodsCallback} />}
        visible={isShowGoods} />
      <Page
        title={`产品批量导入`}
        isMaximize={true}
        body={
          <GoodsImport
            country={country}
            currency={currency}
            reload={reloadSupplier}
            onCloseCallback={() => setShowImport(false)}
          />}
        onCloseCallback={() => setShowImport(false)}
        visible={isShowImport}
      />
    </div>
  );
});
